var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9797 13.7662C21.9418 13.606 21.8649 13.4575 21.7559 13.3341C21.6469 13.2107 21.509 13.1161 21.3547 13.0587L14.1534 10.3575L15.9859 1.19124C16.0274 0.978267 15.9985 0.757575 15.9036 0.562468C15.8086 0.367361 15.6528 0.208424 15.4596 0.109643C15.2664 0.0108611 15.0464 -0.0224058 14.8326 0.0148621C14.6188 0.0521299 14.423 0.15791 14.2746 0.316241L0.274651 15.3162C0.160944 15.4361 0.0786877 15.5822 0.0352299 15.7415C-0.00822786 15.9009 -0.0115334 16.0685 0.0256088 16.2295C0.062751 16.3904 0.139184 16.5397 0.248079 16.6639C0.356974 16.7881 0.49494 16.8834 0.649651 16.9412L7.8534 19.6425L6.0259 28.7987C5.98441 29.0117 6.01331 29.2324 6.10824 29.4275C6.20318 29.6226 6.359 29.7816 6.55218 29.8803C6.74537 29.9791 6.96545 30.0124 7.1792 29.9751C7.39296 29.9379 7.58879 29.8321 7.73715 29.6737L21.7372 14.6737C21.8488 14.5539 21.9293 14.4085 21.9716 14.2502C22.0139 14.092 22.0166 13.9258 21.9797 13.7662ZM8.67715 25.745L9.9859 19.1975C10.0327 18.9653 9.99562 18.724 9.88117 18.5166C9.76671 18.3092 9.58234 18.1491 9.3609 18.065L2.7559 15.5837L13.3334 4.25124L12.0259 10.7987C11.9791 11.031 12.0162 11.2723 12.1306 11.4797C12.2451 11.6871 12.4295 11.8471 12.6509 11.9312L19.2509 14.4062L8.67715 25.745Z",
    fill: "#A38150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic3.5119dd90ab727389b4ea8aae5c4d305a.svg";
export { ForwardRef as ReactComponent };